<template functional>
  <h1
    v-if="props.size == 'extralarge'"
    :class="['uppercase', 'font-bold', $options.sizeClass(props.size)]"
  >
    <slot />
  </h1>
  <h2
    v-else-if="props.size == 'large'"
    :class="['uppercase', 'font-bold', $options.sizeClass(props.size)]"
  >
    <slot />
  </h2>
  <h3
    v-else-if="props.size == 'medium'"
    :class="['font-bold', $options.sizeClass(props.size)]"
  >
    <slot />
  </h3>
  <h4 v-else :class="['font-bold', $options.sizeClass(props.size)]">
    <slot />
  </h4>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      required: false,
      default: 'large'
    }
  },
  sizeClass(size) {
    const sizeClasses = {
      extralarge: 'text-6xl',
      large: 'text-2xl',
      medium: 'text-xl',
      'small-medium': 'text-lg',
      small: 'text-base'
    }
    return sizeClasses[size]
  }
}
</script>
